import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import Button from '../buttons/Button';
import Select from '../form/selects/Select';
import UploadDragDropFiles from '../upload-drag-drop-files/UploadDragDropFiles';
import creditTypes from './../../static-data/credit-types.json';
import FileList from '../file-list/FileList';
import validateFile from './../../services/validateFile';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';

const FinancialDataFiles = ( props ) => {
    let [ buttonError, setButtonError ]             = useState(false);
    let [ buttonText, setButtonText ]               = useState("Wczytaj / Przeciągnij pliki dokumentów finansowych");
    let [ disabledButton, setDisabledButton ]       = useState(false);
    let [ update, setUpdate ]             = useState(0);
    const dispatch                        = useDispatch()
    let financialDataFiles                  = useSelector(state => state.financialDataFiles)
    
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }
      
      
    useEffect(() => {
        setUpdate(update + 1);
    }, [financialDataFiles]);

      let setFiles = (val) => {
          let files = financialDataFiles;
          for (let i = 0; i < val.length; i++) {
              const el = val[i];
              let validate = validateFile(1048576, 2, files.length, el);
              setButtonError( validate.error )
              setButtonText( validate.message )
              if ( !validate.error ) {
                files.push(el);
              }
          }          
          dispatch({ type: 'FINANCIAL_DATA_FILES_CHANGE', value: files })
          setUpdate(++update);
      }
      let removeFile = ( index ) => {
            let files = financialDataFiles;
            files.splice( index, 1);   
            dispatch({ type: 'FINANCIAL_DATA_FILES_CHANGE', value: files })
            setUpdate(--update);
            setButtonError( false )
            setButtonText( 'Przeciągnij plik / <br /> Wczytaj z dysku' )
      }
      

    return (
        <div className="real-estates financial-data-files">
            <Heading title="Dane finansowe - opcja do wczytania dokumentów" medium smallMargin /> 
            <Heading title="Rachunek zysków i strat / Bilans / Księga przchodów i rozchodów / PIT" small />
            <div className="row">
                {/* <Heading title="Dodaj wykaz zobowiązań" /> */}
                { update && update >= 0 &&
                    <UploadDragDropFiles setFunction={ ( val ) => setFiles(val)  }
                        buttonText={ buttonText }
                        error={ buttonError } 
                        update={update}
                        tip={ true } 
                        tipHeader="Wczytaj plik"
                        tipText="Dodaj dokumenty finansowe, jeśli nie wypełniłeś tych pól na formularzu. Wczytaj plik w formacie .jpg lub .pdf. Waga pojedynczego pliku nie może być większa niż 1MB. Maksymalnie można załączyć 2 pliki." /> 
                }
                { financialDataFiles.length > 0  &&
                    <FileList   update={ update } 
                                files={ financialDataFiles }
                                remove={ ( val ) => removeFile( val ) } />
                }
            </div>
        </div>
    )
}

export default FinancialDataFiles;